import axios from 'axios';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import TagHttpClient from '~src/httpClient/TAG/TagHttpClient';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { IAnalyticsConnectionMetadata } from '~src/settings/types/ISiteSettingsForSiteAdmin';

import { AnalyticsConnectionOptionsForFlowResult, GetAnalyticsConnectionOptionsForFlowRequest } from '../serverApi/requests/GetAnalyticsConnectionOptionsForFlowRequest';
import { FlowAnalyticsExtensionConnection, FlowAnalyticsExtensionConnectionSelection, FlowAnalyticsExtensionConnectionUpdate } from '../serverApi/types/FlowAnalyticsExtensionConnection';

const connectionUrl = (flowLuid: string) => `${WebHttpClient.FILE_UPLOAD_API_PREFIX}flows/${encodeURIComponent(flowLuid)}/analyticsExtensions`;

export const FlowAnalyticsExtensions = {
  async getSelection(flowLuid: string): Promise<FlowAnalyticsExtensionConnection | null> {
    if (!FeatureFlags.prepScriptNodeAnalyticsExtensionsEnabled) {
      return null;
    }
    return getSessionManagementServiceInstance().sendRequestWithinSession(async () => {
      const response = await axios.get<FlowAnalyticsExtensionConnectionSelection>(connectionUrl(flowLuid));
      return response.data.connection ?? null;
    });
  },

  async getOptions(flowLuid: string): Promise<ReadonlyArray<IAnalyticsConnectionMetadata>> {
    if (!FeatureFlags.prepScriptNodeAnalyticsExtensionsEnabled) {
      return [];
    }
    const response = await TagHttpClient.sendTagRequest<{ flow_luid: string }, AnalyticsConnectionOptionsForFlowResult>(new GetAnalyticsConnectionOptionsForFlowRequest(flowLuid));
    if (response.errors?.length || !Array.isArray(response.connectionMetadataList)) {
      throw new Error('Invalid Analytics Extension connections response');
    }
    return response.connectionMetadataList;
  },

  async updateConnection(flowLuid: string, connectionLuid: string): Promise<void> {
    if (!FeatureFlags.prepScriptNodeAnalyticsExtensionsEnabled) {
      throw new Error('Flow Analytics Extensions are disabled');
    }
    const request: FlowAnalyticsExtensionConnectionUpdate = { connectionLuid };
    await getSessionManagementServiceInstance().sendRequestWithinSession(() => axios.put<void>(connectionUrl(flowLuid), request));
  },
};
